import { z } from 'zod';
/**
 * Szinsemak.
 *
 * Ket csoport, ket izleshez. A SKANDINAV semak illeszkednek a mostani
 * arculathoz (docs/06-design-system.md): meleg, visszafogott szinek, amik sok
 * avatar mellett sem lesznek zajosak. Az ELENK csoport a batrabbaknak szol.
 *
 * Minden sema CSAK az akcentus-csaladot valtoztatja meg. A hattér, a szoveg es
 * a keretek maradnak - kulonben a "szin informacio, nem dekoracio" szabaly
 * borulna: ha a temaval egyutt a felulet fel szinvilaga valtozik, az olvasatlan
 * jelzes elveszti a kiemelt szerepet.
 */
export const themeModes = ['light', 'dark', 'system'];
export const themeModeSchema = z.enum(themeModes);
export const colorSchemes = [
    'petrol',
    'agyag',
    'zsalya',
    'homok',
    'levendula',
    'szen',
    'padlizsan',
    'klementin',
    'jade',
    'laguna',
];
export const colorSchemeSchema = z.enum(colorSchemes);
export const COLOR_SCHEMES = {
    petrol: { name: 'Petrol', group: 'skandinav', swatch: 'oklch(52% 0.088 224)' },
    agyag: { name: 'Agyag', group: 'skandinav', swatch: 'oklch(54% 0.105 45)' },
    zsalya: { name: 'Zsálya', group: 'skandinav', swatch: 'oklch(50% 0.075 155)' },
    homok: { name: 'Homok', group: 'skandinav', swatch: 'oklch(55% 0.09 78)' },
    levendula: { name: 'Levendula', group: 'skandinav', swatch: 'oklch(52% 0.085 300)' },
    szen: { name: 'Szén', group: 'skandinav', swatch: 'oklch(45% 0.012 66)' },
    padlizsan: { name: 'Padlizsán', group: 'elenk', swatch: 'oklch(44% 0.16 315)' },
    klementin: { name: 'Klementin', group: 'elenk', swatch: 'oklch(58% 0.17 45)' },
    jade: { name: 'Jade', group: 'elenk', swatch: 'oklch(50% 0.14 160)' },
    laguna: { name: 'Laguna', group: 'elenk', swatch: 'oklch(48% 0.15 240)' },
};
export const DEFAULT_SCHEME = 'petrol';
export const SCHEME_GROUP_LABELS = {
    skandinav: 'Skandináv',
    elenk: 'Élénk',
};
//# sourceMappingURL=themes.js.map